module.exports = __webpack_public_path__ + "static/media/DKENA.0f2311f1.svg";